import React from 'react';
import LabeledDatePicker from'../../base/LabeledDatePicker/LabeledDatePicker';

const FaultDate = ({label,onChange,selectedDate}) => {

    return (
        <LabeledDatePicker
            className="col-xs-12"
            id="faultDate"
            inputDivClassName="col-xs-12 col-sm-12"
            name="faultDate"
            label={label}
            onChange={onChange}
            selectedDate={selectedDate} />
    );
}

export default FaultDate;


// WEBPACK FOOTER //
// ./src/components/ComplaintPositionComponents/FaultDate/FaultDate.js